export default class PsConfig {

    static versionNo : String = '1.1';

    ///
    /// API Key to connection with Main Backend
    /// This key must equal with key from backend
    ///
    // static apiKey: String = "teampsisthebest";
    static apiKey: String = "asdasdasdasdas";

    ///
    /// Live Mode
    /// ------------
    /// If you want to upload to server, please enable below and comment Development below
    // static fixedDomain: String = "https://d153-103-120-190-209.ap.ngrok.io"; 
    // static domain: String = "https://d153-103-120-190-209.ap.ngrok.io"; 

    ///
    /// Development Mode
    /// -----------------
    /// Before upload to server, please comment this 2 lines.
    // ///```````````````````````
      static fixedDomain: String = "https://crm.myproperty4u.com/webservices/bartingcoin";     
      static domain: String = "https://crm.myproperty4u.com/webservices/bartingcoin";
    //   static fixedDomain: String = "";     
    //   static domain: String = "";

        // static fixedDomain: String = "http://192.168.0.71:7000/webservices/bartingcoin";
        // static domain: String = "http://192.168.0.71:7000/webservices/bartingcoin";
       
        // static image1: String = "http://192.168.0.71:7000/webservices/bartingcoin";
        static image1: String = "https://crm.myproperty4u.com/webservices/bartingcoin";
     
         static coin: Number = 0
         static cart: Number = 0
    ///
    /// Firebase Config 
    ///
    static firebaseConfig = {
      apiKey: "AIzaSyDqQhGocMEscxD0psUA0xQuOBZc2eFlF2E",
      authDomain: "bating-coin.firebaseapp.com",
        projectId: "bating-coin",
        databaseURL: "https://bating-coin-default-rtdb.firebaseio.com",
      storageBucket: "bating-coin.appspot.com",
      messagingSenderId: "552388976349",
      appId: "1:552388976349:web:229adad53ff932db8f0534",
      measurementId: "G-Y7M2Q3KZ1X"
    };
    
    static firebaseConfig1 = {
        apiKey: "AIzaSyCdK29lWdCbNHbcnLlV9AkXf6YksGnOfJQ",
        authDomain: "fooddeliveryapp-312906.firebaseapp.com",
        databaseURL: "https://fooddeliveryapp-312906-default-rtdb.firebaseio.com",
        projectId: "fooddeliveryapp-312906",
        storageBucket: "fooddeliveryapp-312906.appspot.com",
        messagingSenderId: "451048397900",
        appId: "1:451048397900:web:8a1841b0d7b5283c4ea8e9",
        measurementId: "G-YWRR5PCPM1"
    }
    ///
    /// Base URL * Don't update it *
    ///
    static base: String = PsConfig.domain; 
    static baseUrl: String = PsConfig.domain;
    static fixedPath : String = PsConfig.fixedDomain;
    static image : String = PsConfig.image1;
    
    /// Google Map Key
    /// ----------------
    static mapKey: String = "AIzaSyB4YrDQRfgyBf4CaQNaMjfTAadVeRTKUII";
    

    ///
    /// Price Format
    /// -----------------
    /// Need to change according to your format that you need
    /// E.g.
    /// "#,##0.00"   => 2,555.00
    /// "##0.00"    => 2555.00
    /// "#.00"       => 2555.00
    /// "#,###."      => 2,555
    /// "#,##0.0"    => 2555.0
    /// "###"        => 255
    static  priceFormat : string = '#,##0.0';


    ///
    /// Profile Setting for Item Grid
    /// You can hide/show user profile at item grid
    /// show == show user profile
    /// hide == hide user profile
    ///
    static showUserProfile : string = 'show';


    ///
    /// Map Filter Setting
    ///
    static  noFilterWithLocationOnMap : Boolean= false;

    ///
    /// Promotion Date Pre-define Set
    ///
    /// Type 1 == Fixed Date, Type 2 == Custom Date with user input
    static promotionDays = [
        {
            id:"1", days:7, type:1
        },
        {
            id:"2", days:14, type:1
        },
        {
            id:"3", days:30, type:1
        },
        {
            id:"4", days:60, type:1
        },
        {
            id:"5", days:1, type:2
        }
    ];

    ///
    /// Default Mile for Nearest Search
    ///
    static mile = "8";

    
    

    ///
    /// For default language change, please check
    /// LanguageFragment for language code and country code
    /// ..............................................................
    /// Language             | Language Code     | Country Code
    /// ..............................................................
    /// "English"            | "en"              | "US"
    /// "Arabic"             | "ar"              | "DZ"
    /// "India (Hindi)"      | "hi"              | "IN"
    /// "German"             | "de"              | "DE"
    /// "Spainish"           | "es"              | "ES"
    /// "French"             | "fr"              | "FR"
    /// "Indonesian"         | "id"              | "ID"
    /// "Italian"            | "it"              | "IT"
    /// "Japanese"           | "ja"              | "JP"
    /// "Korean"             | "ko"              | "KR"
    /// "Malay"              | "ms"              | "MY"
    /// "Portuguese"         | "pt"              | "PT"
    /// "Russian"            | "ru"              | "RU"
    /// "Thai"               | "th"              | "TH"
    /// "Turkish"            | "tr"              | "TR"
    /// "Chinese"            | "zh"              | "CN"
    /// ..............................................................
    ///
    static defaultLanguage = {
        languageCode : 'en',
        countryCode : 'US',
        name : 'English US',
        flag :  require('@/assets/flags/usflag.png')
    };
    static supportedLanguages = [
        { languageCode : 'en', countryCode : 'US', name : 'English US', flag: require('@/assets/flags/usflag.png')},
        { languageCode : 'ar', countryCode : 'DZ', name : 'Arabic', flag: require('@/assets/flags/dzFlag.png')},
        { languageCode : 'hi', countryCode : 'IN', name : 'Hindi', flag: require('@/assets/flags/inFlag.jpeg')},
        { languageCode : 'de', countryCode : 'DE', name : 'German', flag: require('@/assets/flags/germanFlag.jpg')},
        { languageCode : 'es', countryCode : 'ES', name : 'Spainish', flag: require('@/assets/flags/spainFlag.jpg')},
        { languageCode : 'fr', countryCode : 'FR', name : 'French', flag: require('@/assets/flags/frenchFlag.jpg')},
        { languageCode : 'id', countryCode : 'ID', name : 'Indonesian', flag: require('@/assets/flags/indonesiaFlag.jpg')},
        { languageCode : 'it', countryCode : 'IT', name : 'Italian', flag: require('@/assets/flags/italyFlag.jpg')},
        { languageCode : 'ja', countryCode : 'JP', name : 'Japanese', flag: require('@/assets/flags/japanFlag.jpg')},
        { languageCode : 'ko', countryCode : 'KR', name : 'Korean', flag: require('@/assets/flags/southkoreaFlag.jpg')},
        { languageCode : 'ms', countryCode : 'MY', name : 'Malay', flag: require('@/assets/flags/malaysiaFlag.jpg')},
        { languageCode : 'pt', countryCode : 'PT', name : 'Potuguese', flag: require('@/assets/flags/potugueseFlag.jpg')},
        { languageCode : 'ru', countryCode : 'RU', name : 'Russian', flag: require('@/assets/flags/russiaFlag.jpg')},
        { languageCode : 'th', countryCode : 'TH', name : 'Thai', flag: require('@/assets/flags/thaiFlag.jpg')},
        { languageCode : 'tr', countryCode : 'TR', name : 'Turkish', flag: require('@/assets/flags/turkishFlag.jpg')},
        { languageCode : 'zh', countryCode : 'CN', name : 'Chinese', flag: require('@/assets/flags/chinaFlag.jpg')}
    ];
        

    /// 
    /// Debug Mode
    ///
    static isDebugMode : Boolean = true;

    /// 
    /// Video Setting
    ///
    static isEnableVideoSetting : Boolean = true;
    
    ///
    /// Notification Setting
    ///
    static enableNotification = 'true';

    static fcmServerKey : string = 'AAAAgJzy3t0:APA91bGYy53o_W-ygBc2AckYF1XwXOCr0ETcnf1Zt2H6YqWKc814R3LADFXzJ7wsX9DnQBV898U5e0hm9-zrMhb5Df7QSUjtwn7GoTg3n_kTG-RXBjdpAMExuyMxI9N7XOivH4GgxJrW';
    
    static firebaseWebPushKeyPair : string = 'BNuCPpnhycYzV_sF4qgN5_ftaKXYhnnqLRCwzLpoSTE19L2uXc48fuRqH09mvmuGdb5_tHN7OFP3U1Xx_0gmNF4';
    
    // static enableNotification = 'true';

    // static fcmServerKey : string = 'AAAA0SHlOiY:APA91bFprl-9OnQA8sFNWZpo0H-9sZkrqJbgeXYLUIZcO-UbEOhtLg8M-lf5LvtfwWB1J_4w1ML0ujmXq6aMeP15CJALI6WWhMUKZFnyLwryxRY0flDIN20497rSy9vSoZXpbxvtihRR';
    
    // static firebaseWebPushKeyPair : string = 'BFg9axbtuw3u1xNeHfOKx2hndhtrHvO8lgZwFTfDpF7lLW0BT2k9Z-uiyMLN9pXiZJYPjkoQV4kCWyetYicfR3o';
    ///
    /// Adsense Setting
    ///
    static adClient = "ca-pub-0000000000000000";
    static adSlot = "0000000000";
    
}
